// 本地存储工具
const STORAGE_KEYS = {
  USER: 'k12_user',
  UNLOCKED_COURSES: 'k12_unlocked_courses',
  LEARNING_PROGRESS: 'k12_learning_progress',
  USED_CDKS: 'k12_used_cdks'
};

// 获取当前登录用户
export const getCurrentUser = () => {
  const userStr = localStorage.getItem(STORAGE_KEYS.USER);
  return userStr ? JSON.parse(userStr) : null;
};

// 设置当前登录用户
export const setCurrentUser = (user) => {
  localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(user));
};

// 退出登录
export const logout = () => {
  localStorage.removeItem(STORAGE_KEYS.USER);
};

// 检查是否登录
export const isLoggedIn = () => {
  return !!getCurrentUser();
};

// 获取已解锁课程列表
export const getUnlockedCourses = () => {
  const coursesStr = localStorage.getItem(STORAGE_KEYS.UNLOCKED_COURSES);
  return coursesStr ? JSON.parse(coursesStr) : [];
};

// 添加已解锁课程
export const addUnlockedCourse = (courseId) => {
  const unlocked = getUnlockedCourses();
  if (!unlocked.includes(courseId)) {
    unlocked.push(courseId);
    localStorage.setItem(STORAGE_KEYS.UNLOCKED_COURSES, JSON.stringify(unlocked));
  }
};

// 检查课程是否已解锁
export const isCourseUnlocked = (courseId) => {
  return getUnlockedCourses().includes(courseId);
};

// 获取学习进度
export const getLearningProgress = (courseId) => {
  const progressStr = localStorage.getItem(STORAGE_KEYS.LEARNING_PROGRESS);
  const allProgress = progressStr ? JSON.parse(progressStr) : {};
  return allProgress[courseId] || { completedLessons: [], lastLesson: 0, totalTime: 0 };
};

// 更新学习进度
export const updateLearningProgress = (courseId, progress) => {
  const progressStr = localStorage.getItem(STORAGE_KEYS.LEARNING_PROGRESS);
  const allProgress = progressStr ? JSON.parse(progressStr) : {};
  allProgress[courseId] = { ...allProgress[courseId], ...progress };
  localStorage.setItem(STORAGE_KEYS.LEARNING_PROGRESS, JSON.stringify(allProgress));
};

// 获取已使用的CDK列表
export const getUsedCDKs = () => {
  const cdksStr = localStorage.getItem(STORAGE_KEYS.USED_CDKS);
  return cdksStr ? JSON.parse(cdksStr) : [];
};

// 标记CDK为已使用
export const markCDKAsUsed = (cdkCode, courseId) => {
  const usedCDKs = getUsedCDKs();
  usedCDKs.push({ code: cdkCode, courseId, usedAt: new Date().toISOString() });
  localStorage.setItem(STORAGE_KEYS.USED_CDKS, JSON.stringify(usedCDKs));
};

// 检查CDK是否已使用
export const isCDKUsed = (cdkCode) => {
  return getUsedCDKs().some(item => item.code === cdkCode);
};

// 格式化时长（分钟转小时分钟）
export const formatDuration = (minutes) => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return hours > 0 ? `${hours}小时${mins}分钟` : `${mins}分钟`;
};

// 格式化日期
export const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
};
